import { ClickProps } from "../../interfaces";

const CartMas = ({onClick} : ClickProps): JSX.Element => (
	<div onClick={onClick}>
		<svg
			version="1.1"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px" y="0px"
			width="485.213px"
			height="485.212px"
			viewBox="0 0 485.213 485.212"
		>
			<g>
				<g>
					<g>
						<polygon points="424.562,363.906 172.036,363.906 65.893,121.304 0.001,121.304 0.001,90.978 85.737,90.978 191.876,333.584 
							424.562,333.584"
						/>
					</g>
					<path d="M272.934,439.727c0,25.109-20.381,45.485-45.49,45.485c-25.142,0-45.488-20.376-45.488-45.485
			c0-25.118,20.346-45.49,45.488-45.49C252.553,394.237,272.934,414.609,272.934,439.727z"/>
					<path d="M424.562,439.727c0,25.109-20.376,45.485-45.485,45.485c-25.118,0-45.49-20.376-45.49-45.485
			c0-25.118,20.372-45.49,45.49-45.49C404.187,394.237,424.562,414.609,424.562,439.727z"/>
					<g>
						<path d="M379.077,0c-58.609,0-106.144,47.532-106.144,106.141c0,58.606,47.534,106.141,106.144,106.141
				c58.604,0,106.135-47.534,106.135-106.141C485.212,47.532,437.682,0,379.077,0z M439.722,121.304h-45.485v45.49h-30.327v-45.49
				h-45.485V90.978h45.485V45.49h30.327v45.488h45.485V121.304z"/>
					</g>
					<path d="M379.077,242.606c-59.234,0-109.256-38.144-128.088-90.978h-99.36l60.654,151.629h212.279l35.008-87.482
			C436.944,232.42,409.255,242.606,379.077,242.606z"/>
				</g>
			</g>
		</svg>
	</div>
);

export default CartMas